import { useState } from 'react';

export default function Testimonials() {
  const testimonials = [
    {
      name: 'Majiro Efevwerha',
      vehicle: '2024 Range Rover Sport',
      savings: '$12,450',
      image: 'https://public.readdy.ai/ai/img_res/903f96d706f7d4d2f0167fe2a4c3a08b.jpg',
      quote: 'Kevin found me the exact Range Rover Sport I wanted and saved me over $12,000! His connections with dealerships are incredible. The whole process was seamless and professional.',
      rating: 5
    },
    {
      name: 'Thomas Cesar',
      vehicle: '2026 Lexus RX 350 F Sport Series 3',
      savings: '$17,655',
      image: 'https://readdy.ai/api/search-image?query=Professional%20businessman%20in%20late%2040s%20with%20salt%20and%20pepper%20hair%20wearing%20charcoal%20gray%20suit%20standing%20in%20three%20quarter%20view%20position%20in%20upscale%20dealership%20showroom%20with%20his%20stunning%20pearl%20white%202025%20Lexus%20RX%20350%20F%20Sport%20luxury%20SUV%20prominently%20displayed%20taking%20up%20majority%20of%20background%20showing%20full%20side%20profile%20of%20vehicle%20with%20distinctive%20F%20Sport%20mesh%20grille%20LED%20headlights%20and%20sporty%20body%20lines%20polished%20marble%20floors%20premium%20lighting%20and%20modern%20glass%20architecture%20creating%20elegant%20automotive%20showcase%20with%20the%20white%20Lexus%20as%20the%20hero%20element&width=400&height=400&seq=thomas-lexus-rx-fsport-white-full-vehicle-v3&orientation=squarish',
      quote: 'One of my proudest moments as Mr Auto Broker—helping a close friend and VIP client save $17,655 on his new 2026 Lexus RX 350 F Sport Series 3, all in under 30 minutes of his time. $4,500 off the new vehicle, $7,500 above market for his trade-in, and $5,655 in tax savings. This is why I left the showroom—to protect buyers and deliver real results.',
      rating: 5
    },
    {
      name: 'Sarah M.',
      vehicle: '2024 Honda CR-V',
      savings: '$4,200',
      image: 'https://readdy.ai/api/search-image?query=Happy%20young%20professional%20woman%20in%20casual%20business%20attire%20standing%20beside%20her%20new%20silver%20Honda%20CR-V%20SUV%20in%20modern%20dealership%20showroom%20with%20bright%20lighting%20and%20clean%20minimalist%20design%20showing%20excited%20smile%20and%20holding%20car%20keys&width=400&height=400&seq=sarah2024&orientation=squarish',
      quote: 'Kevin made buying my first car stress-free! He explained everything clearly and got me an amazing deal. I saved over $4,000 compared to what dealerships were offering me directly.',
      rating: 5
    },
    {
      name: 'Michael T.',
      vehicle: '2024 Ford F-150',
      savings: '$6,800',
      image: 'https://readdy.ai/api/search-image?query=Rugged%20confident%20man%20in%20casual%20flannel%20shirt%20and%20jeans%20standing%20next%20to%20his%20powerful%20black%20Ford%20F-150%20pickup%20truck%20in%20outdoor%20dealership%20lot%20with%20blue%20sky%20background%20showing%20satisfied%20smile%20and%20crossed%20arms&width=400&height=400&seq=michael2024&orientation=squarish',
      quote: 'Best decision I made was calling Kevin. He found the exact F-150 configuration I wanted and negotiated a price I couldn\'t believe. Saved me weeks of dealership hopping!',
      rating: 5
    },
    {
      name: 'Adnan Hashmi',
      vehicle: '2026 Honda Pilot',
      savings: '$8,500',
      image: 'https://readdy.ai/api/search-image?query=Distinguished%20South%20Asian%20professional%20businessman%20approximately%2040%20years%20old%20with%20dark%20brown%20skin%20tone%20wearing%20an%20elegant%20tailored%20charcoal%20gray%20three-piece%20suit%20with%20burgundy%20tie%20standing%20proudly%20beside%20his%20brand%20new%20jet%20black%202026%20Honda%20Pilot%20SUV%20with%20chrome%20accents%20in%20a%20luxurious%20modern%20car%20dealership%20showroom%20featuring%20marble%20floors%20dramatic%20spotlighting%20and%20floor-to-ceiling%20windows%20creating%20an%20upscale%20premium%20automotive%20environment&width=400&height=400&seq=adnan-hashmi-honda-pilot-black-2026-v2&orientation=squarish',
      quote: 'Kevin\'s expertise and negotiation skills are unmatched. He secured an incredible deal on my 2026 Honda Pilot and made the entire buying experience effortless. Absolutely recommend his services!',
      rating: 5
    }
  ];

  const [currentIndex, setCurrentIndex] = useState(0);

  const nextTestimonial = () => {
    setCurrentIndex((prev) => (prev + 1) % testimonials.length);
  };

  const prevTestimonial = () => {
    setCurrentIndex((prev) => (prev - 1 + testimonials.length) % testimonials.length);
  };

  const current = testimonials[currentIndex];

  return (
    <section id="testimonials" className="py-20 bg-gray-100">
      <div className="max-w-7xl mx-auto px-6">
        <div className="bg-white rounded-3xl shadow-2xl overflow-hidden">
          <div className="grid md:grid-cols-5 gap-0">
            {/* Left Visual */}
            <div className="md:col-span-2 relative h-96 md:h-auto">
              <img
                src={current.image}
                alt={current.name}
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-r from-teal-500/20 to-blue-500/20"></div>
            </div>

            {/* Right Content */}
            <div className="md:col-span-3 p-12 md:p-16 flex flex-col justify-center">
              <div className="text-sm text-gray-500 uppercase tracking-wider mb-4">
                (VERIFIED WOODBRIDGE CUSTOMER)
              </div>

              <h3 className="text-5xl font-bold text-gray-900 mb-2">
                This Changed How I Buy Cars
              </h3>
              <div className="text-5xl italic text-gray-400 mb-12">Forever</div>

              <div className="mb-8">
                <i className="ri-double-quotes-l text-6xl text-purple-200"></i>
                <p className="text-xl text-gray-700 leading-relaxed my-6">
                  {current.quote}
                </p>
                <i className="ri-double-quotes-r text-6xl text-purple-200"></i>
              </div>

              <div className="text-xl font-bold text-gray-900 mb-12">
                — {current.name}, {current.vehicle}
              </div>

              {/* Navigation Controls */}
              <div className="flex items-center space-x-4">
                <button
                  onClick={prevTestimonial}
                  className="w-12 h-12 rounded-full border-2 border-gray-300 flex items-center justify-center hover:border-gray-900 transition-all cursor-pointer"
                >
                  <i className="ri-arrow-left-line text-xl text-gray-700"></i>
                </button>
                <button
                  onClick={nextTestimonial}
                  className="w-12 h-12 rounded-full bg-gray-900 flex items-center justify-center hover:bg-gray-800 transition-all shadow-lg cursor-pointer"
                >
                  <i className="ri-arrow-right-line text-xl text-white"></i>
                </button>
                <div className="ml-4 text-sm text-gray-500">
                  {currentIndex + 1} / {testimonials.length}
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Additional Testimonials Grid */}
        <div className="mt-16 grid md:grid-cols-3 gap-8">
          {[
            {
              name: "David K.",
              location: "Markham",
              rating: 5,
              text: "Saved me $2,900 on my Mazda CX-5. The AI consultation was so easy and the broker was incredibly professional."
            },
            {
              name: "Lisa P.",
              location: "Toronto",
              rating: 5,
              text: "Best car buying experience ever! No dealership visits, no pressure, just great savings and excellent service."
            },
            {
              name: "Robert H.",
              location: "Brampton",
              rating: 5,
              text: "I was amazed at how much time and money this saved me. The broker's connections are the real deal."
            }
          ].map((testimonial, index) => (
            <div key={index} className="bg-white rounded-2xl p-8 shadow-lg">
              <div className="flex mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-yellow-400 text-xl"></i>
                ))}
              </div>
              <p className="text-gray-700 mb-6 leading-relaxed">{testimonial.text}</p>
              <div className="font-semibold text-gray-900">{testimonial.name}</div>
              <div className="text-sm text-gray-500">{testimonial.location}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
